import AWS from 'aws-sdk'
import { nanoid } from 'nanoid'

AWS.config.update({
  region: 'us-east-1',
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'us-east-1:7c62b4ba-85df-4745-98b5-230670c01d27'
  })
})

const S3 = new AWS.S3({ apiVersion: '2006-03-01' })

export const FILE_TYPES = {
  AUDIO: 'audio',
  IMAGE: 'image',
  VIDEO: 'video'
}

export const uploadToS3 = async ({ file, user, type }) => {
  const extension = getFileExtension(file.name)
  const contentType = getContentType(type, extension)

  if (!contentType) {
    throw new Error('Unsupported file type or extension')
  }

  const params = {
    Bucket: 'i.moal.tech',
    Key: `${nanoid()}.${extension}`,
    Body: file,
    ContentType: contentType,
    ACL: 'public-read'
  }

  const options = {
    tags: [{ Key: 'user', Value: user._id || '' }]
  }

  const { Key } = await S3.upload(params, options).promise()

  return `https://i.moal.tech/${Key}`
}

const getContentType = (type, extension) => {
  const mimeTypes = {
    image: {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      svg: 'image/svg+xml',
      webp: 'image/webp'
    },
    audio: {
      mp3: 'audio/mpeg',
      wav: 'audio/wav',
      flac: 'audio/flac',
      ogg: 'audio/ogg',
      aac: 'audio/aac',
      m4a: 'audio/mp4'
    },
    video: {
      mp4: 'video/mp4',
      webm: 'video/webm',
      ogv: 'video/ogg',
      mov: 'video/quicktime',
      avi: 'video/x-msvideo',
      mkv: 'video/x-matroska'
    }
  }

  return mimeTypes[type]?.[extension] || null
}

const getFileExtension = (fileName) => {
  return fileName.split('.').pop().toLowerCase()
}
